import React, { forwardRef } from 'react';

import { buttonize, withSuspense } from 'venn-utils';

import { type HTMLProps } from '../factory';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { blockDisplayHeader, isSelectedBlockState, selectedBlocksState } from 'venn-state';

export interface BlockRootProps extends HTMLProps<'div'> {
  id: string;
  children: React.ReactNode;
}

export const BLOCK_CONTAINER_CLASS = 'venn-block-container';

const InternalBlockRoot = forwardRef<HTMLDivElement, BlockRootProps>((props, ref) => {
  const { id, children } = props;

  const title = useRecoilValue(blockDisplayHeader(id));
  const isBlockSelected = useRecoilValue(isSelectedBlockState(id));

  const onBlockClick = useRecoilCallback(
    ({ set }) =>
      (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
        e.stopPropagation();
        if (isBlockSelected) {
          return;
        }

        set(selectedBlocksState, [id]);
      },
    [isBlockSelected, id],
  );

  return (
    <div ref={ref} id={id} key={id} data-testid={`qa-${lowerCaseHeaderName(title)}`} className="w-full group/block">
      <div {...buttonize(onBlockClick)}>
        <div className={`${BLOCK_CONTAINER_CLASS} w-full h-full flex flex-col`} id={id}>
          {children}
        </div>
      </div>
    </div>
  );
});

InternalBlockRoot.displayName = 'BlockRoot';

export const BlockRoot = withSuspense(null, InternalBlockRoot);

const lowerCaseHeaderName = (header: string) => header.toLowerCase().replace(/ /g, '-');
